import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=363cef90&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=ts&"
export * from "./TabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363cef90",
  null
  
)

export default component.exports